export const ATTENDENT_HOURS = {
  INITIAL: 6,
  FINAL: 23,
}
